export default __webpack_public_path__ + "static/media/Sugo.007e0654.jpg";